type Props = {
  desktopVideoUrl: string;
  mobileVideoUrl: string;
};

export function HeroVideo({ desktopVideoUrl, mobileVideoUrl }: Props) {
  return (
    <>
      {/* Desktop Video */}
      <video
        src={desktopVideoUrl}
        className="absolute top-0 left-0 w-full h-full object-cover hidden md:block"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <track kind="captions" />
      </video>
      {/* Mobile Video */}
      <video
        src={mobileVideoUrl}
        className="absolute top-0 left-0 w-full h-full object-cover block md:hidden"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <track kind="captions" />
      </video>
    </>
  );
}
